import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';
import { memberPortal } from "../member-portal";
import { bookingFormCommon } from '../c005-bookingform-common';
import { adobeDataLayerWrapper } from "../adobeDataLayerMethod";
require('parsley');
import 'html2canvas';

export class enrichCardProfile {
	private updateFormprofile: any = $('#member-profile-enrichcard');
	private updateForm: any = $('#member-personaldetails-update');
	private memberBase: any = new memberPortal();
	private bookingformcommon = new bookingFormCommon();
	private temporaryCard: any = $('#member-profile-enrichcard');
	private statecodes: any = [];
	private enrichaddress: any = [];
	private $profileCookie: any = null;
	initSelectizeInputs(): any {
		let _self = this;
		_self.$profileCookie = $("#profile_cookie").val();
		var countryInput = $('#enrich-profile--personal-country');
		var getCountryOptions = $.Deferred();
		let countrycodeurl: string = '';
		var stateCodeInput = $('#enrich-profile--personal-state');
		var getStateCodeOptions = $.Deferred();
		let stateCodeUrl: string = '';

		$("#enrichCard--success-container").hide();
		$("#enrichCard--error-container").hide();
		$("#enrichCard-submit-success").hide();
		$("#enrichCard-submit-error").hide();

		// disable input fields ALWAYS
		if(this.getCookie('profileSessionEnabled').length === 0) {
				let toDisableInputs:any = $('#enrichLcpFormUpdate').find('#enrichcard-profile--personal-address-line-1, #enrichcard-profile--personal-address-line-2, #enrichcard-profile--personal-address-line-3, #enrich-profile--personal-country, #enrich-profile--personal-state, #enrichcard-profile--personal-address-city, #enrichcard-profile--personal-address-postcode');
				toDisableInputs.each((i:number, el:any) => {
					$(el).attr({
						'disabled': 'disabled'
					});
					$(el).prev().css({
						'background-color': '#eee',
						'border-top-left-radius':'10px',
						'border-top-right-radius': '10px'
					});
			});
		}
		if (window.location.hostname === 'localhost' && window.location.port == "5000") {
			countrycodeurl = '/dummy-data/countrycode.json';
			stateCodeUrl = '/dummy-data/statecodes.json';
		}
		else {
			countrycodeurl = '/content/dam/mas/json/countrycode.json';
			stateCodeUrl = '/content/dam/mas/json/statecodes.json'
		}

		$.get(countrycodeurl)
			.done((data: any) => {


				var listItems = "<option value=''> </option>";
				if (window.location.hostname === 'localhost') {
					if (typeof data === 'string') {
						data = JSON.parse(data);
					}
				}

				for (var i = 0; i < data.Countries.length; i++) {
					listItems += "<option value='" + data.Countries[i].Code + "'>" + data.Countries[i].Name + "</option>";
				}
				getCountryOptions.resolve(listItems);

			})
			.fail((error: any) => {
				getCountryOptions.reject(error);
			});
		$.when(getCountryOptions).done(function (countryOptions: any) {
			countryInput.html(countryOptions);

		});

		var getnewCountryOptions = $.Deferred();
		$.get(stateCodeUrl)
		.done((data:any) => {
			var listItems = "<option value=''> </option>";
			if (window.location.hostname === 'localhost' && window.location.port == "5000") {
				if (typeof data === 'string') {
					data=JSON.parse(data);
				}
			}	
			 localStorage.setItem("lcp-search", JSON.stringify(data));		
			for (var i = 0; i < data.CountriesList.length; i++) {
				listItems += "<option value='" + data.CountriesList[i].CountryCode + "'>" + data.CountriesList[i].CountryName + "</option>";
			}
			getnewCountryOptions.resolve(listItems);
		})
		.fail((error:any) => {
			getnewCountryOptions.reject(error);
		});
		$.get(stateCodeUrl)
			.done((data: any) => {
				var listItems = "<option value=''> </option>";
				if (window.location.hostname === 'localhost') {
					if (typeof data === 'string') {
						data = JSON.parse(data);
					}
				}
				_self.statecodes = data
				_self.handleCountryStates()
				for (var i = 0; i < data.CountriesList.length; i++) {
					for (var j = 0; j < data.CountriesList[i].StatesList.length; j++) {
						if (data.CountriesList[i].StatesList[j].StateCode != 'NULL') {
							listItems += "<option value='" + data.CountriesList[i].StatesList[j].StateCode + "'>" + data.CountriesList[i].StatesList[j].StateName + "</option>";
						}
					}
				}
				getStateCodeOptions.resolve(listItems);

			})
			.fail((error: any) => {
				getStateCodeOptions.reject(error);
			});
		$.when(getCountryOptions,getnewCountryOptions,getStateCodeOptions).done(function (stateCodeOptions: any,countryOptions: any) {
			countryInput.html(countryOptions);
			stateCodeInput.html(stateCodeOptions);
		});

		$.when(getCountryOptions, getnewCountryOptions,getStateCodeOptions).done(function () {
			let inputSelectArr: any = $.makeArray(_self.updateFormprofile.find('select'))
			_self.memberBase.initSelectizeInputs(inputSelectArr);
		})
	}
	populateFields(): any {
		let _self = this;
		let populateurl = '/bin/services/new/getEnrichCardDetails';
		var data = {
			'action': 'fetch'
		};
		$.ajax({
			type: 'POST',
			url: populateurl,
			data: data,
			success: function (msg: any) {
				//_self.redirectUser(msg);
				if (msg != "{}") {
					let res = JSON.parse(msg);
					$('#prefrence--card-name').val(res.cardUsername);
					$('.card--username').html(res.cardUsername);
					$('.card--number').html(res.cardNumber);
					$('.card--expiry').html(res.cardExpiry);
					$('#enrichcard-profile--personal-address-line-1').val(res.homeAddress1);
					$('#enrichcard-profile--personal-address-line-2').val(res.homeAddress2);
					$('#enrichcard-profile--personal-address-line-3').val(res.homeAddress3);
					$('#enrichcard-profile--personal-address-city').val(res.homeCity);
					$('#enrichcard-profile--personal-address-postcode').val(res.homePostCode);
					let countryInput = $('.enrich-profile--personal-country select');
					countryInput.selectize({});
					countryInput[0].selectize.setValue(res.homeCountry);
					let stateInput = $('.enrich-profile--personal-state select');
					stateInput.selectize({});
					stateInput[0].selectize.setValue(res.homeState);

				}
				else {
					$("#update-profile-failure").fadeIn();
				}

			},
			error: function (msg: any) {
				console.log(msg);
			}
		});
	}
	getCookie(cookieName: any) {
		let cookies:any  = [];
		document.cookie.split(';').forEach(function(el) {
			let [key,value] = el.split('=');
			cookies.push({key: key.trim(), value : value});
		});
		let ck = cookies.filter((c: any) => {
			return cookieName === c.key;
		})
		return ck;
	}
	handleCountryStates(): any {
		let _self = this
		let countryselect = $('#enrich-profile--personal-country');
		let listItems: any[] = [];
		countryselect.on("change", function () {
			$(".partner-state").fadeIn()
			let availableStates = $.grep(_self.statecodes.CountriesList, function (country: any, ind: any) {
				return country.CountryCode == countryselect.val()

			})
			let sel = $('#enrich-profile--personal-state')[0].selectize
			sel.clear()
			if (availableStates[0]) {
				availableStates = availableStates[0].StatesList
				listItems = []
				for (var i = 0; i < availableStates.length; i++) {
					listItems[i] = { 'text': availableStates[i].StateName, 'value': availableStates[i].StateCode }
				}
			} else {
				listItems = [{ 'text': '-', value: 'NULL' }]
				sel.setValue("NULL")
				sel.setTextboxValue('-')
			}
			sel.clearOptions()
			sel.addOption(listItems)
			if (listItems.length === 1) {
				sel.setValue(listItems[0].value)
			}

		})
	}
	initcheckbox() {
		let _self = this;
		let enrich_country = _self.enrichaddress.homeCountry;
		let enrich_state = _self.enrichaddress.homeState;
		let enrich_address1 = _self.enrichaddress.homeAddress1;
		let enrich_address2 = _self.enrichaddress.homeAddress2;
		let enrich_address3 = _self.enrichaddress.homeAddress3;
		let enrich_postalcode = _self.enrichaddress.homePostCode;
		let enrich_city = _self.enrichaddress.homeCity;
		$('#prefrence--checkbox-address').click(function () {
			let _self = this;
			if ($(this).prop("checked") == true) {
				$('#enrich-profile--personal-country')[0].selectize.setValue(enrich_country)
				$('#enrichcard-profile--personal-address-line-1	').val(enrich_address1);
				$('#enrichcard-profile--personal-address-line-2').val(enrich_address2);
				$('#enrichcard-profile--personal-address-line-3').val(enrich_address3);
				$('#enrich-profile--personal-state')[0].selectize.setValue(enrich_state)
				$('#enrichcard-profile--personal-address-postcode').val(enrich_postalcode)
				$('#enrichcard-profile--personal-address-city').val(enrich_city);
			}
			else if ($(this).prop("checked") == false) {
				$('#enrichcard-profile--personal-address-line-1	').val('');
				$('#enrichcard-profile--personal-address-line-2').val('');
				$('#enrichcard-profile--personal-address-line-3').val('');
				$('#enrichcard-profile--personal-address-city').val('');
				$('#enrichcard-profile--personal-address-postcode').val('')
				$('#enrich-profile--personal-country')[0].selectize.setValue('');
				$('#enrich-profile--personal-state')[0].selectize.setValue('');
			}
		});
	}

	redirectUser(msg: any) {
		if (msg.indexOf("timeout") > -1) {
			msg = msg.replace("timeout-", "");
			window.location.href = msg;
		}
	}
	initPrintSaveCardLCP(): any {
		let _self = this;
		let printBtn = $('#members-print-card');
		let saveBtn = $('#members-save-card');
		let cardImage = $('.members--card-image');
		let requestCard = $('#request-card');
		let redeemNow = $('#redeem_now');

		let cardAspectRatio = 273 / 137;

		printBtn.on('click', (e: any) => {
			e.preventDefault();
			e.stopPropagation();
			adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Enrich Card',
                'clickName': 'click:btn-click:print-card',
                'componentType': 'btn',
                'componentName': 'members-save-card',
                'componentID': 'members-save-card',
				'attributes': []
            });

			html2canvas(cardImage[0], {
				onrendered: function (canvas: any) {
					let nW: any = window.open('', '', 'width=600,height=400');
					nW.document.write('<img src="' + canvas.toDataURL() + '"/>');
					nW.focus();
					setTimeout(() => {
						nW.print();
						nW.close();
					}, 600);
				}
			});
		});

		redeemNow.on('click', (e: any) => {
			e.preventDefault();
			e.stopPropagation();
			let populateurl = '/bin/services/new/requestCard';
			let pointsDeducted = $('#redeemPointsVal').html();
			let updateAddress = $('#prefrence--checkbox-address').is(":checked");
			$("#enrichCard-submit-success").hide();
			$("#enrichCard-submit-error").hide();
			var data = {
				'action': 'requestPayment',
				'updateAddress': updateAddress,
				'homeCountry': $('#enrich-profile--personal-country').val(),
				'pointsDeducted': pointsDeducted
			};
			_self.bookingformcommon.preloader();
			$.ajax({
				type: 'POST',
				url: populateurl,
				data: data,
				success: function (msg: any) {
					// _self.redirectUser(msg);
					_self.bookingformcommon.preloaderClose();
					if (msg.errorCode == "OK") {
						$('html, body').animate({
							'scrollTop': 0
						}, 500, function () {
							$("#enrichCard-submit-success").html($("#paymentSuccess").html());
							$("#enrichCard-submit-success").show();
						});
					} else {
						$('html, body').animate({
							'scrollTop': 0
						}, 500, function () {
							$("#enrichCard-submit-error").html($("#errorMessage").html());
							$("#enrichCard-submit-error").show();
						});
					}
				},
				error: function (error: any) {
					_self.bookingformcommon.preloaderClose();
					if (error.errorCode == "NOK") {
						$('html, body').animate({
							'scrollTop': 0
						}, 500, function () {
							$("#enrichCard--error-container").html($("#errorMessage").html());
							$("#enrichCard--error-container").show();
						});
					}
				}
			});

		});

		requestCard.click((e: any) => {
			e.preventDefault();
			e.stopPropagation();
			let ValidtionResult: any = false;
			let suffBalance: any = false;
			let milesCountCookie = getCookie("milesCount");
			if ((parseInt(milesCountCookie)) < (parseInt($("#redeemPointsVal").html()))) {
				$("#insufficientPoints").show();
				suffBalance = true;
			}
			

			if ($('#enrichcard-profile--personal-address-line-1').val() == "") {
				$('#enrichcard-profile--personal-address-line-1').addClass('has-error');
				ValidtionResult = true;
			}
			else {
				$('#enrichcard-profile--personal-address-line-1').removeClass('has-error');
			}

			if ($('#enrichcard-profile--personal-address-postcode').val() == "") {
				$('#enrichcard-profile--personal-address-postcode').addClass('has-error');
				ValidtionResult = true;
			}
			else {
				$('#enrichcard-profile--personal-address-postcode').removeClass('has-error');
			}

			if ($('#enrichcard-profile--personal-address-city').val() == "") {
				$('#enrichcard-profile--personal-address-city').addClass('has-error');
				ValidtionResult = true;
			}
			else {
				$('#enrichcard-profile--personal-address-city').removeClass('has-error');
			}

			if ($('#enrich-profile--personal-state').val() == "") {
				$('.enrich-profile--personal-state').addClass('has-error');
				ValidtionResult = true;
			}
			else {
				$('.enrich-profile--personal-state').removeClass('has-error');
			}

			if ($('#enrich-profile--personal-country').val() == "") {
				$('.enrich-profile--personal-country').addClass('has-error');
				ValidtionResult = true;
			}
			else {
				$('.enrich-profile--personal-country').removeClass('has-error');
			}
			if (ValidtionResult) {
				$("#enrichCard--error-container").html("Please fill mandatory fields.");
				$("#enrichCard--error-container").show();
				$('html, body').animate({ scrollTop: '100px' });
			}
			if (!ValidtionResult && !suffBalance) {
				$("#enrichCard--success-container").hide();
				$("#enrichCard--error-container").hide();
				$("#enrichCard-submit-success").hide();
				$("#enrichCard-submit-error").hide();
				let populateurl = '/bin/services/new/requestCard';
				let pointsDeducted = $('#redeemPointsVal').html();
				var data = {
					'action': 'requestCard',
					'pointsDeducted': pointsDeducted,
					'homeAddress1': $('#enrichcard-profile--personal-address-line-1').val(),
					'homeAddress2': $('#enrichcard-profile--personal-address-line-2').val(),
					'homeAddress3': $('#enrichcard-profile--personal-address-line-3').val(),
					'homeCity': $('#enrichcard-profile--personal-address-city').val(),
					'homePostCode': $('#enrichcard-profile--personal-address-postcode').val(),
					'homeCountry': $('#enrich-profile--personal-country').val(),
					'homeState': $('#enrich-profile--personal-state').val()
				};
				_self.bookingformcommon.preloader();
				$.ajax({
					type: 'POST',
					url: populateurl,
					data: data,
					success: function (msg: any) {
						// _self.redirectUser(msg);
						_self.bookingformcommon.preloaderClose();
						if (msg.errorCode == "OK") {
							$('html, body').animate({
								'scrollTop': 0
							}, 500, function () {
								$("#request-card").addClass("disabled");
								$('#redeem_now').removeClass("disabled");
								$("#redeem_now").removeClass("redeem_now_disabled");
								$("#request-card").addClass("redeem_now_disabled");
								$("#redeem_now").addClass("redeem_now_active");
								$("#enrichCard-submit-success").html($("#cardRequestSuccess").html());
								$("#enrichCard-submit-success").show();
								$('#enrichcard-profile--personal-address-line-1').prop("disabled", true);
								$('#enrichcard-profile--personal-address-line-2').prop("disabled", true);
								$('#enrichcard-profile--personal-address-line-3').prop("disabled", true);
								$('#enrichcard-profile--personal-address-city').prop("disabled", true);
								$('#enrichcard-profile--personal-address-postcode').prop("disabled", true);
								$(".enrich-profile--personal-state .selectize-input").css({ 'pointer-events': 'none' });
								$(".enrich-profile--personal-country .selectize-input").css({ 'pointer-events': 'none' });
								$(".enrich-profile--personal-country .selectize-input").after().css({ 'background-color': '#eee' });
								$(".enrich-profile--personal-state .selectize-input").after().css({ 'background-color': '#eee' });
							});
						} else {
							$('html, body').animate({
								'scrollTop': 0
							}, 500, function () {
								let errorMessage = "updateProfileErrorMessage";
								if(msg.message == "updateProfileErrorMessage")
									errorMessage =	$("#updateProfileErrorMessage").html();
								else
									errorMessage =	$("#errorMessage").html();
								$("#enrichCard-submit-error").html(errorMessage);
								$("#enrichCard-submit-error").show();
							});
						}
					},
					error: function (error: any) {
						_self.bookingformcommon.preloaderClose();
						if (error.errorCode == "NOK") {
							$('html, body').animate({
								'scrollTop': 0
							}, 500, function () {
								$("#enrichCard-submit-error").html($("#errorMessage").html());
								$("#enrichCard-submit-error").show();
							});
						}
					}
				});
			}

		});

		saveBtn.click((e: any) => {
			e.preventDefault();
			e.stopPropagation();
			adobeDataLayer.push('click', {
                'pageName': '',
                'pageType': 'Enrich Profile - Enrich Card',
                'clickName': 'click:btn-click:save-card',
                'componentType': 'btn',
                'componentName': 'members-save-card',
                'componentID': 'members-save-card',
				'attributes': []
            });
			$("#enrichCard--success-container").hide();
			$("#enrichCard--error-container").hide();
			let populateurl = '/bin/services/new/requestCard';
			let nameOncard = $('#prefrence--card-name').val();
			$('.card--username').html(nameOncard);
			var data = {
				'action': 'updateNameOnCard',
				'nameOnCard': nameOncard
			};
			_self.bookingformcommon.preloader();
			$.ajax({
				type: 'POST',
				url: populateurl,
				data: data,
				success: function (msg: any) {
					// _self.redirectUser(msg);
					_self.bookingformcommon.preloaderClose();
					if (msg.errorCode == "OK") {
						$('html, body').animate({
							'scrollTop': 0
						}, 500, function () {
							$("#enrichCard--success-container").html($("#nameUpdateSuccess").html());
							$("#enrichCard--success-container").show();
						});
					} else {
						$('html, body').animate({
							'scrollTop': 0
						}, 500, function () {
							$("#enrichCard--error-container").html($("#updateProfileErrorMessage").html());
							$("#enrichCard--error-container").show();
						});
					}
				},
				error: function (error: any) {
					_self.bookingformcommon.preloaderClose();
					if (error.errorCode == "NOK") {
						$('html, body').animate({
							'scrollTop': 0
						}, 500, function () {
							$("#enrichCard--error-container").html($("#errorMessage").html());
							$("#enrichCard--error-container").show();
						});
					}
				}
			});
			html2canvas(cardImage[0], {
				onrendered: function (canvas: any) {
					_self.temporaryCard
						.append('<a class="hidden" id="temp-card-image-for-dl" href="' + canvas.toDataURL() + '" download="member-card.png">Download</a>');

					let tempDlBtn = $('#temp-card-image-for-dl');

					tempDlBtn[0].click();
				}
			});
		});

		function getCookie(name:string): any {
			var value = "; " + document.cookie;
			var parts = value.split("; " + name + "=");
			var cookieVal:any;
			if (parts.length == 2) {
				cookieVal = parts.pop().split(";").shift();
				return cookieVal;
			}
		}

		$("#enrich-profile--personal-country").change(function () {
			if ($("#enrich-profile--personal-country").val() == 'MY') {
				$("#redeemPointsVal").html($("#malaysiaPointsRedeem").html());
			} else {
				$("#redeemPointsVal").html($("#internationalPointsRedeem").html());
			}
		});

		$("#enrich-profile--personal-state").change(function () {
			if ($("#enrich-profile--personal-state").val() == 'NA') {
				$(".distance-padding-mobile.enrich-profile--personal-state").hide();
			}else{
				$(".distance-padding-mobile.enrich-profile--personal-state").show();
			}
		});

	}
}

let scope: Element = document.querySelector('#member-profile-enrichcard');

if (scope) {
	try {
		let memberenrichcard = new enrichCardProfile();
		var adobeDataLayer = new adobeDataLayerWrapper();
		memberenrichcard.initSelectizeInputs();
		memberenrichcard.populateFields();
		memberenrichcard.initPrintSaveCardLCP();
		adobeDataLayer.push('pageLoaded', {
			'pageName': '',
			'pageType': 'Enrich Profile - Enrich Card',
			'attributes': []
		});
		// memberenrichcard.initcheckbox();
	} catch (e) { console.error(e); }
}